import { BasicMetadata, BroIdMetadata, EditMetadata } from "./MetaData";
import { Task } from "./Task";

export const gldProcessReferenceOptions = [
  {
    value: "NEN_EN_ISO22475v2006_C11v2010",
    label: "NEN EN ISO 22475 v2006 + C11 v2010",
  },
  {
    value: "NEN_ISO21413v2005",
    label: "NEN ISO 21413 v2005",
  },
  {
    value: "NPR_ISO.TR23211v2009",
    label: "NPR ISO/TR 23211 v2009",
  },
  {
    value: "RWSgwmon",
    label: "RWS gwmon",
  },
  {
    value: "STOWAgwst",
    label: "STOWA gwst",
  },
  {
    value: "vitensMeetprotocolGrondwater",
    label: "Vitens meetprotocol grondwater",
  },
  {
    value: "waternetMeetprocedure",
    label: "Waternet meetprocedure",
  },
  {
    value: "NEN5120v1991",
    label: "NEN 5120 v1991",
    onlyImbroA: true,
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export type GldProcessReferenceOptions = (typeof gldProcessReferenceOptions)[number]["value"];

export const gldEvaluationProcedureOptions = [
  {
    value: "brabantWater2013",
    label: "Brabant Water 2013",
  },
  {
    value: "eijkelkampDataValidatiev0.0.9",
    label: "Eijkelkamp data validatie v0.0.9",
  },
  {
    value: "oordeelDeskundige",
    label: "Oordeel deskundige",
  },
  {
    value: "PMBProtocolDatakwaliteitscontroleQC2018v2.0",
    label: "PMB Protocol datakwaliteitscontrole QC 2018 v2.0",
  },
  {
    value: "RWSAATGrondwaterv1.0",
    label: "RWS AAT Grondwater v1.0",
  },
  {
    value: "validatieprocedureEvidesWaterbedrijf",
    label: "Validatieprocedure Evides Waterbedrijf",
  },
  {
    value: "vitensBeoordelingsprotocolGrondwater",
    label: "Vitens beoordelingsprotocol grondwater",
  },
  {
    value: "warecoWaterDataValidatieProtocolv20200219",
    label: "Wareco Water Data Validatie Protocol v20200219",
  },
  {
    value: "waternetBeoordelingsprocedure",
    label: "Waternet beoordelingsprocedure",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export type GldEvaluationProcedureOptions = (typeof gldEvaluationProcedureOptions)[number]["value"];

export const gldMeasurementInstrumentOptions = [
  {
    value: "akoestischeSensor",
    label: "Akoestische sensor",
  },
  {
    value: "akoestischHandapparaat",
    label: "Akoestisch handapparaat",
  },
  {
    value: "analoogPeilklokje",
    label: "Analoog peilklokje",
  },
  {
    value: "druksensor",
    label: "Druksensor",
  },
  {
    value: "elektronischPeilklokje",
    label: "Elektronisch peilklokje",
  },
  {
    value: "opzetStuk",
    label: "Opzetstuk",
  },
  {
    value: "radarsensor",
    label: "Radarsensor",
  },
  {
    value: "stereoDruksensor",
    label: "Stereo druksensor",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
  {
    value: "onbekendPeilklokje",
    label: "Onbekend peilklokje",
    onlyImbroA: true,
  },
] as const;
export type GldMeasurementInstrumentOptions =
  (typeof gldMeasurementInstrumentOptions)[number]["value"];

export const gldAirPressureCompensationTypeOptions = [
  {
    value: "capillair",
    label: "Capillair",
  },
  {
    value: "gecorrigeerdLokaleMeting",
    label: "Gecorrigeerd lokale meting",
  },
  {
    value: "KNMImeting",
    label: "KNMI meting",
  },
  {
    value: "monitoringnetmeting",
    label: "Monitoringnetmeting",
  },
  {
    value: "putlocatiemeting",
    label: "Putlocatiemeting",
  },
  {
    value: "",
    label: "Geen",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;
export type GldAirPressureCompensationTypeOptions =
  (typeof gldAirPressureCompensationTypeOptions)[number]["value"];

export const gldObservationTypeOptions = [
  {
    value: "controlemeting",
    label: "Controlemeting",
  },
  {
    value: "reguliereMeting",
    label: "Reguliere meting",
  },
] as const;
export type GldObservationTypeOptions = (typeof gldObservationTypeOptions)[number]["value"];

export const gldStatusQualityControlOptions = [
  {
    value: "volledigBeoordeeld",
    label: "Volledig beoordeeld",
  },
  {
    value: "voorlopig",
    label: "Voorlopig",
  },
  {
    value: "onbekend",
    label: "Onbekend",
  },
  // FUTURE?
  // {
  //   value: "",
  //   label: "controle",
  // },
] as const;
export type GldStatusQualityControlOptions =
  (typeof gldStatusQualityControlOptions)[number]["value"];

export interface GLDStartRegistrationData {
  objectIdAccountableParty: string;
  gmwBroId: string;
  tubeNumber: string;
  groundwaterMonitoringNets: string[];
}

export interface GLDClosureData {
  eventDate?: string; // Not actually used / required for message
}

export interface GLDAdditionData {
  processReference: string; // MeetProcedure
  evaluationProcedure: string; // BeoordelingsProcedure
  measurementInstrumentType: string; // MeetInstrumentType
  airPressureCompensationType: string; // TypeLuchtdrukCompensatie
  investigatorKvk: string; // Uitvoerder, kvk nummer max 8 tekens
  observationType: string; // MetingType
  statusQualityControl: string; // Validatiestatus
}
export interface EditGLDAdditionData extends GLDAdditionData {
  observationId: string; // Uuid of the observation
}
export interface DeleteGLDAdditionData extends EditGLDAdditionData {
  beginPosition?: string; // ISO date string
  endPosition?: string; // ISO date string
  timeValuePairs: { time: string; value: number; status_quality_control: string }[]; // List of dictionaries with time and value keys, representing the timeseries data
}

export type GLDStartRegistrationTask = Task<GLDStartRegistrationData, BasicMetadata>;
export type EditGLDStartRegistrationTask = Task<GLDStartRegistrationData, EditMetadata>;

export interface GLDAdditionTask extends Task<GLDAdditionData, BroIdMetadata> {
  timeseriesFile: Blob;
}
export interface EditGLDAdditionTask extends Task<EditGLDAdditionData, EditMetadata> {
  timeseriesFile: Blob;
}

export type DeleteGLDAdditionTask = Task<DeleteGLDAdditionData, EditMetadata>;

export type GLDClosureTask = { metadata: EditMetadata };
